import { Modal } from '@cloudscape-design/components';
import LoadingSpinner from 'src/components/LoadingSpinner';
import React, { useEffect } from 'react';
import { useApi } from 'src/hooks/useApi';
import { useRenderContent } from 'src/components/ArtifactDetail/components/useRenderContent';

interface ArtifactDetailModalProps {
    modalHref: string;
    setModalHref: (href: string) => void;
    artifactId: string;
}

export const ArtifactDetailModal = ({
    modalHref,
    setModalHref,
    artifactId,
}: ArtifactDetailModalProps) => {
    const { makeRequest, data, error, loading } = useApi({
        method: 'GET',
    });
    useEffect(() => {
        if (modalHref.length) {
            const url = `learning-artifacts/v2/xref/${artifactId}/${encodeURI(
                modalHref.split('_x')[0]
            )}`;
            makeRequest({ url });
        }
    }, [modalHref]);

    const { artifactHtml } = useRenderContent({
        artifactId,
        data,
        loading,
        setModalHref,
    });
    return (
        <Modal
            visible={!!modalHref.length}
            onDismiss={() => {
                setModalHref('');
            }}
            size={'large'}
        >
            {loading ? (
                <LoadingSpinner />
            ) : (
                <object className={'xyleme-container'}>{artifactHtml}</object>
            )}
        </Modal>
    );
};
